import script from "./staItem.vue?vue&type=script&setup=true&lang=js"
export * from "./staItem.vue?vue&type=script&setup=true&lang=js"

import "./staItem.vue?vue&type=style&index=0&id=6b591fb0&lang=css"

const __exports__ = script;

export default __exports__